var _rect, _rect2, _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeoBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 634,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 247,
    width: 5,
    height: 31,
    rx: 2.5,
    fill: "#F9DB6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 260,
    width: 5,
    height: 31,
    rx: 2.5,
    transform: "rotate(90 776 260)",
    fill: "#F9DB6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#387",
    fillOpacity: 0.1,
    d: "M624 518h41v41h-41zM863 527h70v70h-70z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 372.5,
    cy: 18.5,
    r: 15,
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 615.5,
    r: 15,
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjYzNCIgdmlld0JveD0iMCAwIDE0NDAgNjM0IiBmaWxsPSJub25lIj4KICAgIDxyZWN0IHg9Ijc1OCIgeT0iMjQ3IiB3aWR0aD0iNSIgaGVpZ2h0PSIzMSIgcng9IjIuNSIgZmlsbD0iI0Y5REI2RCIvPgogICAgPHJlY3QgeD0iNzc2IiB5PSIyNjAiIHdpZHRoPSI1IiBoZWlnaHQ9IjMxIiByeD0iMi41IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA3NzYgMjYwKSIgZmlsbD0iI0Y5REI2RCIvPgogICAgPHJlY3QgeD0iNjI0IiB5PSI1MTgiIHdpZHRoPSI0MSIgaGVpZ2h0PSI0MSIgZmlsbD0iIzMzODg3NyIgZmlsbC1vcGFjaXR5PSIwLjEiLz4KICAgIDxyZWN0IHg9Ijg2MyIgeT0iNTI3IiB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIGZpbGw9IiMzMzg4NzciIGZpbGwtb3BhY2l0eT0iMC4xIi8+CiAgICA8Y2lyY2xlIGN4PSIzNzIuNSIgY3k9IjE4LjUiIHI9IjE1IiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KICAgIDxjaXJjbGUgY3g9Ijk4LjUiIGN5PSI2MTUuNSIgcj0iMTUiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLW9wYWNpdHk9IjAuMDciIHN0cm9rZS13aWR0aD0iNyIvPgo8L3N2Zz4K";
export { SvgSeoBg as ReactComponent };